export const columnTypeOptions = [
    {
        value: "DATA",
        label: "DATA"
    }, {
        value: "COMMAND",
        label: "COMMAND"
    }
]
export const columnAlignmentOptions = [
    {
        value: "LEFT",
        label: "LEFT"
    }, {
        value: "CENTER",
        label: "CENTER"
    }, {
        value: "RIGHT",
        label: "RIGHT"
    }
]
export const pipeArgOptions = [
    {
        value: "boolean",
        label: "Boolean"
    },
    {
        value: "percent",
        label: "Percent"
    },
    {
        value: "measure",
        label: "Measure"
    },
    {
        value: "number",
        label: "Number"
    }
]